// src/hooks/useUpdateUserProfile.ts
import { useState } from 'react';
import { Customer } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useUpdateDeviceCrmData = () => {
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  const updateDeviceCrmData = async (deviceCrmData: Customer, ean: string | undefined) => {
    const token = sessionState.account?.token;
    if (!token) {
      setError('Login or token is missing');
      return false;
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/device/crm/${ean}`, {
        method: 'PUT',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(deviceCrmData),
      });

      if (!response.ok) {
        throw new Error('Failed to update user profile');
      }

      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return false;
    }
  };

  return { updateDeviceCrmData, error };
};

export default useUpdateDeviceCrmData;
